import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export type CMSPage = {
  id: string
  content: {
    id: string
    field: string
    content: string
  }[]
}

@Injectable({
    providedIn: 'root',
})
export class CmsPageService {

  constructor(
    private http: HttpClient
  ){}

  public getPageContentBySlug(slug: string): Observable<{[key: string]: string}> {
    return this.http
        .get<{page: CMSPage}>(environment.api + `/cms-pages/page/${slug}`)
        .pipe(
          map(result => {
            return result.page.content.reduce((acc, curr) => {
              acc[curr.field] = curr.content;
              return acc;
            }, {} as {[key: string]: string});
          })
        )
  }
}